export default "__VITE_ASSET__DtlDiVWL__"